import React from "react";
import * as PropTypes from "prop-types";
import { Get } from "react-axios";
import moment from "moment";

import { DataProvider } from "./Providers";
import { TrafficUrlProvider } from "./UrlProviders";


class TrafficGet extends DataProvider {

}

TrafficGet.propTypes = {
    ...DataProvider.propTypes,
    apiUrlProvider: PropTypes.instanceOf(TrafficUrlProvider).isRequired
};


export class StreetInfoGet extends TrafficGet {
    render() {
        const { children, apiUrlProvider } = this.props;

        return (
            <Get url={apiUrlProvider.getStreetInfoUrl()} onLoading={this.onLoading} onSuccess={this.onSuccess} onError={this.onError}>
                {(error, response, isLoading, makeRequest, axios) => {
                    return typeof children === "function" ? children(error, response, isLoading, makeRequest, axios) : children
                }}
            </Get>
        )
    }
}

StreetInfoGet.propTypes = {
    ...TrafficGet.propTypes
};


export class StreetTimeseriesGet extends TrafficGet {
    render() {
        const { children, apiUrlProvider, streetName } = this.props;
        const params = {
            direction: this.props.direction,
            from: this.props.from.toString(),
            until: this.props.until.toString()
        };

        return (
            <Get url={apiUrlProvider.getStreetTimeseriesUrl(streetName)} params={params} onLoading={this.onLoading} onSuccess={this.onSuccess} onError={this.onError}>
                {(error, response, isLoading, makeRequest, axios) => {
                    return typeof children === "function" ? children(error, response, isLoading, makeRequest, axios) : children
                }}
            </Get>
        )
    }
}

StreetTimeseriesGet.propTypes = {
    ...TrafficGet.propTypes,
    streetName: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
    from: PropTypes.instanceOf(moment).isRequired,
    until: PropTypes.instanceOf(moment).isRequired,
};
